import React from 'react';
import { AppFormLayout, AppForm, AppFormPageProps, AppFormItemEnum } from 'qcc'
import { appEnum } from 'utils/appEnum'

export default class DeviceEditForm extends React.PureComponent<AppFormPageProps> {
  state = {}

  render() {
    let { formData, mode, id } = this.props;
    return (<AppFormLayout defaultButton mode={this.props.mode}>
      <AppFormLayout.Form>
        <AppForm entity='pos_device' loadingData={false} mode={mode} keyValue={id} formData={formData} afterSave={() => { this.props.afterSave && this.props.afterSave() }}>
          <AppForm.Section labelWidth={120}>
            <AppForm.Item itemType={AppFormItemEnum.hidden} field='project_id' dataType={appEnum.dataType.number} />
            <AppForm.Item field='mac' itemType={AppFormItemEnum.input} label="POS设备S/N码" req unRepeat scopeField='project_id' />
            <AppForm.Item field='name' itemType={AppFormItemEnum.input} label="设备名称" req />
            <AppForm.Item field='version' itemType={AppFormItemEnum.input} label="版本" req />
            <AppForm.Item field='remark' itemType={AppFormItemEnum.text} label="备注" req />
          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
    </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/pos/device/DeviceEditForm.tsx